export const PERMISSION_DEFINITIONS = [
  { key: 'dashboard.access', label: 'Início', group: 'Geral', roles: ['admin', 'gerente', 'operador_caixa', 'garcom', 'cozinheiro', 'entregador', 'estoquista', 'zelador'] },
  { key: 'overview.access', label: 'Visão geral', group: 'Geral', roles: ['admin', 'gerente'] },
  { key: 'tables.access', label: 'Acessar Mesas', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa', 'garcom'] },
  { key: 'tables.manage', label: 'Cadastrar e organizar mesas', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'comandas.access', label: 'Acessar Comandas', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa', 'garcom'] },
  { key: 'comandas.manage', label: 'Cadastrar e organizar comandas', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'pos.access', label: 'Balcão (PDV)', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'delivery.access', label: 'Delivery', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa', 'entregador'] },
  { key: 'kds.access', label: 'Preparo (KDS)', group: 'Atendimento', roles: ['admin', 'gerente', 'garcom', 'cozinheiro'] },
  { key: 'orders.access', label: 'Pedidos', group: 'Atendimento', roles: ['admin', 'gerente', 'operador_caixa', 'garcom'] },
  { key: 'cash.access', label: 'Caixa e movimentações', group: 'Caixa e financeiro', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'cash.review', label: 'Conferir e corrigir fechamentos de caixa', group: 'Caixa e financeiro', roles: ['admin', 'gerente'] },
  { key: 'financial.access', label: 'Financeiro', group: 'Caixa e financeiro', roles: ['admin', 'gerente'] },
  { key: 'reports.access', label: 'Relatórios', group: 'Caixa e financeiro', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'products.access', label: 'Visualizar produtos, categorias e serviços', group: 'Cadastros', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'products.manage', label: 'Cadastrar e editar produtos', group: 'Cadastros', roles: ['admin', 'gerente'] },
  { key: 'catalog.manage', label: 'Editar categorias e serviços', group: 'Cadastros', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'stock.access', label: 'Estoque', group: 'Cadastros', roles: ['admin', 'gerente', 'operador_caixa', 'estoquista'] },
  { key: 'promotions.access', label: 'Promoções e descontos', group: 'Cadastros', roles: ['admin', 'gerente'] },
  { key: 'customers.access', label: 'Clientes', group: 'Cadastros', roles: ['admin', 'gerente'] },
  { key: 'locations.access', label: 'Endereços e localização', group: 'Cadastros', roles: ['admin', 'gerente'] },
  { key: 'reviews.access', label: 'Avaliações', group: 'Cadastros', roles: ['admin', 'gerente'] },
  { key: 'users.manage', label: 'Usuários e permissões', group: 'Administração', roles: ['admin'], delegable: false },
  { key: 'settings.access', label: 'Configurações gerais', group: 'Administração', roles: ['admin', 'gerente'] },
  { key: 'scale.settings', label: 'Configuração da balança', group: 'Administração', roles: ['admin', 'gerente', 'operador_caixa'] },
  { key: 'printing.settings', label: 'Impressão e hardware', group: 'Administração', roles: ['admin', 'gerente'] },
  { key: 'menu.settings', label: 'Configuração do cardápio', group: 'Administração', roles: ['admin', 'gerente'] },
  { key: 'audit.access', label: 'Auditoria de cancelamentos', group: 'Administração', roles: ['admin', 'gerente'] },
  { key: 'qrcode.access', label: 'QR Code', group: 'Administração', roles: ['admin', 'gerente'] },
];

const DEFAULT_ROLES = Object.fromEntries(PERMISSION_DEFINITIONS.map((item) => [item.key, item.roles]));

const PATH_PERMISSIONS = [
  ['/admin/visao-geral', 'overview.access'],
  ['/admin/mesas', 'tables.access'],
  ['/admin/comandas', 'comandas.access'],
  ['/admin/balcao', 'pos.access'],
  ['/admin/delivery', 'delivery.access'],
  ['/admin/preparo', 'kds.access'],
  ['/admin/pedidos', 'orders.access'],
  ['/admin/caixa', 'cash.access'],
  ['/admin/financeiro', 'financial.access'],
  ['/admin/relatorios', 'reports.access'],
  ['/admin/produtos', 'products.access'],
  ['/admin/categorias', 'products.access'],
  ['/admin/servicos', 'products.access'],
  ['/admin/estoque', 'stock.access'],
  ['/admin/promocoes', 'promotions.access'],
  ['/admin/clientes', 'customers.access'],
  ['/admin/usuarios', 'users.manage'],
  ['/admin/localizacao', 'locations.access'],
  ['/admin/avaliacoes', 'reviews.access'],
  ['/admin/configuracoes/balanca', 'scale.settings'],
  ['/admin/configuracoes/impressao', 'printing.settings'],
  ['/admin/configuracoes/hardware', 'printing.settings'],
  ['/admin/configuracoes/setores-impressao', 'printing.settings'],
  ['/admin/configuracoes/cardapio', 'menu.settings'],
  ['/admin/configuracoes', 'settings.access'],
  ['/admin/auditoria', 'audit.access'],
  ['/admin/qrcode', 'qrcode.access'],
];

export const permissionForPath = (path = '') => {
  const clean = path.split('?')[0];
  if (clean === '/admin' || clean === '/admin/') return 'dashboard.access';
  return PATH_PERMISSIONS.find(([prefix]) => clean.startsWith(prefix))?.[1] || null;
};

export const hasEffectivePermission = (user, permission, fallbackRoles) => {
  if (!user) return false;
  if (user.role === 'superadmin' || user.role === 'developer' || user.role === 'admin') return true;
  const overrides = user.permission_overrides || {};
  if (permission && typeof overrides[permission] === 'boolean') return overrides[permission];
  const roles = DEFAULT_ROLES[permission] || fallbackRoles || [];
  return roles.includes(user.role);
};

export const defaultPermissionForRole = (role, permission) => (
  role === 'admin' || (DEFAULT_ROLES[permission] || []).includes(role)
);
